var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fixed-button',{attrs:{"is-visible":"","width":_vm.width,"height":_vm.height}},[_c('i',{staticClass:"fa fa-envelope fa-fw",style:(_vm.iconStyles)}),_vm._v(" "),(_vm.messageCount)?_c('span',{staticClass:"message-count badge"},[_vm._v(_vm._s(_vm.messageCount))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }